/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Loading"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var enIN = Object.assign(TranslationProviderComponent, {
  translations
});

export { enIN as e };
//# sourceMappingURL=en-IN-C6-GV0qg.js.map
